var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStarIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 17,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m9 1.026 2.404 4.308.113.202.227.045 4.84.955-3.354 3.617-.158.17.028.23.587 4.898L9.21 13.38 9 13.282l-.21.097-4.477 2.072.587-4.898.028-.23-.158-.17-3.354-3.617 4.84-.955.227-.045.113-.202L9 1.026Z",
  stroke: "#FFC700"
})));
export { SvgStarIcon as ReactComponent };
export default __webpack_public_path__ + "25377cb95b7b3b59a04fea29fba35633.svg";